import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.inquiryDetail.loading;
export const selectErrorMessage = (state: RootState) =>
  state.inquiryDetail.error;
export const inquiryDetailDataResponse = (state: RootState) =>
  state.inquiryDetail.inquiryDetailResponse;
